import React, { useId } from 'react';
import {
  CABLE_ICON_OUTLINE,
  COPPER_COLOR,
  COPPER_SECTION_COLOR
} from './cableIconStyles';

const UnipolarCableIcon = ({ className = '', style = {} }) => {
  const gradientId = `cable-jacket-gradient-${useId().replace(/[^a-zA-Z0-9_-]/g, '')}`;
  const sectionGradientId = `${gradientId}-section`;

  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 145 610 225"
    preserveAspectRatio="xMidYMid meet"
    aria-hidden="true"
    focusable="false"
    data-cable-icon="unipolar"
    className={className}
    style={style}
  >
    <defs>
      <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="var(--cable-jacket-primary, #ef4444)" />
        <stop offset="0.48" stopColor="var(--cable-jacket-primary, #ef4444)" />
        <stop offset="0.52" stopColor="var(--cable-jacket-secondary, #ef4444)" />
        <stop offset="1" stopColor="var(--cable-jacket-secondary, #ef4444)" />
      </linearGradient>
      <linearGradient id={sectionGradientId} x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="var(--cable-jacket-section-primary, #f98e88)" />
        <stop offset="0.48" stopColor="var(--cable-jacket-section-primary, #f98e88)" />
        <stop offset="0.52" stopColor="var(--cable-jacket-section-secondary, #f98e88)" />
        <stop offset="1" stopColor="var(--cable-jacket-section-secondary, #f98e88)" />
      </linearGradient>
    </defs>
    <g>
      <path
        data-cable-part="jacket"
        fill={`url(#${gradientId})`}
        stroke={CABLE_ICON_OUTLINE}
        strokeWidth="4"
        strokeLinecap="square"
        strokeLinejoin="round"
        d="M55.775 157.726v.25c-25.5 3.581-45.657 46-45.657 97.75s20.157 94.169 45.657 97.75l283.25-.5-2.25-194.25-281-1z"
      />
      <path
        data-cable-part="jacket-section"
        fill={`url(#${sectionGradientId})`}
        stroke={CABLE_ICON_OUTLINE}
        strokeWidth="4"
        strokeLinecap="square"
        strokeLinejoin="round"
        d="M385.424 255.727c0 75.44-40.958 122.591-73.724 84.87-15.207-17.506-24.575-49.858-24.575-84.87 0-75.44 40.958-122.591 73.724-84.871 15.207 17.507 24.575 49.859 24.575 84.871z"
      />
      <path
        data-cable-part="copper"
        fill={COPPER_COLOR}
        stroke={CABLE_ICON_OUTLINE}
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
        d="M342.15 192.226c-17.106.656-30.875 28.86-30.875 63.5 0 35.05 14.113 63.515 31.5 63.5l224.136-.189-.589-126.645s-223.97-.174-224.172-.166z"
      />
      <path
        data-cable-part="copper-section"
        fill={COPPER_SECTION_COLOR}
        stroke={CABLE_ICON_OUTLINE}
        strokeWidth="1.717"
        strokeLinecap="square"
        strokeLinejoin="round"
        d="M597.271 255.727c0 48.88-26.247 79.43-47.245 54.99-9.746-11.343-15.749-32.305-15.749-54.99 0-48.88 26.248-79.43 47.246-54.99 9.745 11.342 15.748 32.304 15.748 54.99z"
      />
    </g>
    </svg>
  );
};

export default UnipolarCableIcon;
